import { Moment } from "moment";
import { useMemo } from "react";
import { FieldError, FieldValues, RegisterOptions } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createEnum, reduceObject } from "../../../utils/utils";

export const countries = createEnum({
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barb.",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herz.",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "St-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Is.",
  CD: "Dem. Rep. Congo",
  CF: "Central African Rep.",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Côte d'Ivoire",
  CK: "Cook Is.",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cabo Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czechia",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Rep.",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "W. Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Is.",
  FM: "Micronesia",
  FO: "Faeroe Is.",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Eq. Guinea",
  GR: "Greece",
  GS: "S. Geo. and the Is.",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Is.",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "Br. Indian Ocean Ter.",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "St. Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Is.",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Sint Maarten",
  MG: "Madagascar",
  MH: "Marshall Is.",
  MK: "Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "N. Mariana Is.",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Fr. Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "St. Pierre and Miquelon",
  PN: "Pitcairn Is.",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Is.",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "S. Sudan",
  ST: "São Tomé and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten (Dutch part)",
  SY: "Syria",
  SZ: "Swaziland",
  TC: "Turks and Caicos Is.",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatican",
  VC: "St. Vin. and Gren.",
  VE: "Venezuela",
  VG: "British Virgin Is.",
  VI: "U.S. Virgin Is.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna Is.",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
});

export const reverseCountries: Record<
  typeof countries["values"][number],
  typeof countries["keys"][number]
> = reduceObject(
  countries.enum,
  (acc, val, key) => ({ ...acc, [val]: key }),
  {}
) as Record<
  typeof countries["values"][number],
  typeof countries["keys"][number]
>;

export const useIdentityAttachmentType = () => {
  const { t } = useTranslation("common");
  return useMemo(
    () =>
      createEnum({
        PASSPORT: t("passport"),
        ID_CARD: t("id-card"),
        DRIVING_LICENSE: t("driving-license"),
      }),
    [t]
  );
};

export type IdentityAttachmentType = ReturnType<
  typeof useIdentityAttachmentType
>["T"];

export type Attachment = {
  fileName: string;
  id: string; //uuid
  type: IdentityAttachmentType | AddressAttachmentType;
  uploadedAt: Moment;
};

export const useAddressAttachmentType = () => {
  const { t } = useTranslation("common");

  return useMemo(
    () =>
      createEnum({
        UTILITY_BILL: t("utility-bill"),
        BANK_STATEMENT: t("bank-statement"),
        RENT_AGREEMENT: t("rent-agreement"),
        EMPLOYER_LETTER: t("employer-letter"),
        TAX_BILL: t("tax-bill"),
      }),
    [t]
  );
};

export type AddressAttachmentType = ReturnType<
  typeof useAddressAttachmentType
>["T"];

export const useFaceAttachmentType = () => {
  const { t } = useTranslation("common");

  return useMemo(
    () =>
      createEnum({
        FACE: t("face"),
      }),
    [t]
  );
};

export type FaceAttachmentType = ReturnType<typeof useFaceAttachmentType>["T"];

export type Rules = RegisterOptions<FieldValues>;

const validationErrors: Record<
  FieldError["type"] | string,
  (fieldDesc: string) => string
> = {
  required: (x) => `${x} is required`,
  max: (x) => `${x} is too big`,
  maxLength: (x) => `${x} is too long`,
  min: (x) => `${x} is too small`,
  minLength: (x) => `${x} is too short`,
  pattern: (x) => `${x} has an invalid format`,
  setValueAs: (x) => x,
  shouldUnregister: (x) => x,
  validate: (x) => x,
  value: (x) => x,
  valueAsDate: (x) => x,
  valueAsNumber: (x) => x,
  //TODO: improve on these
};

export const getValidationError = (
  fieldDesc: string,
  err: FieldError | undefined
) =>
  err && validationErrors[err.type]
    ? validationErrors[err.type](fieldDesc)
    : undefined;

export const processingStatus = createEnum({
  COMPLETED: "Completed",
  SIGNUP_ERROR: "Signup Error",
  KYC_UPLOAD_PENDING: "KYC Upload Pending",
  KYC_UPLOAD_ERROR: "KYC Upload Error",
  LOGIN_FAILED: "Login Failed",
  PENDING: "Pending",
});
